import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AppStoreKeys } from 'src/app/store/store-keys.module';

import {
  PatchDocFiltersDictionnaryAction,
  PatchIsBatAction,
  PatchShowPopupWarningAction
} from './property-bag-state.actions';
import { DocFiltersDictionnary, PropertyBag } from './property-bag-state.model';

@State<PropertyBag>({
  name: AppStoreKeys.PropertyBagState,
  defaults: {
    isBat: null,
    showPopupWarning: true,
    docFiltersDictionnary: new DocFiltersDictionnary()
  } as PropertyBag
})
@Injectable()
export class PropertyBagState {
  @Selector()
  public static isBat(state: PropertyBag): boolean {
    return state.isBat;
  }

  @Selector()
  public static showPopupWarning(state: PropertyBag): boolean {
    return state.showPopupWarning;
  }

  @Selector()
  public static docFiltersDictionnary(state: PropertyBag): DocFiltersDictionnary {
    return state.docFiltersDictionnary;
  }

  @Action(PatchIsBatAction)
  patchIsBat(ctx: StateContext<PropertyBag>, action: PatchIsBatAction): void {
    ctx.patchState({
      isBat: action.isBat
    });
  }

  @Action(PatchShowPopupWarningAction)
  patchShowPopupWarning(
    ctx: StateContext<PropertyBag>,
    action: PatchShowPopupWarningAction
  ): void {
    ctx.patchState({
      showPopupWarning: action.showPopupWarning
    });
  }

  @Action(PatchDocFiltersDictionnaryAction)
  patchDocFiltersDictionnary(ctx: StateContext<PropertyBag>, action: PatchDocFiltersDictionnaryAction): void {
    ctx.patchState({
      docFiltersDictionnary: action.docFiltersDictionnary
    });
  }

}
